import useStyles from 'isomorphic-style-loader/useStyles';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { ReactElement } from 'react';

import { DEFAULT_PANEL_ENTITY } from './affected-packages-panel.const';
import s from './affected-packages-panel-header.scss';

export interface AffectedPackagesPanelHeaderProps {
  /**
   * Names the row the panel is open on, as an element when it needs to bring
   * its own truncation.
   */
  title: ReactElement | string;
  /**
   * Noun for the row being stepped through, used in the control labels.
   *
   * @default 'vulnerability'
   */
  entity?: string;
  hasPrev?: boolean;
  hasNext?: boolean;
  onPrev?: () => void;
  onNext?: () => void;
}

export const AffectedPackagesPanelHeader = ({
  title,
  entity = DEFAULT_PANEL_ENTITY,
  hasPrev = false,
  hasNext = false,
  onPrev,
  onNext,
}: AffectedPackagesPanelHeaderProps) => {
  useStyles(s);

  return (
    <div className={s.nav}>
      <button
        className={s.navButton}
        aria-label={`Previous ${entity}`}
        disabled={!hasPrev}
        onClick={onPrev}
        type="button"
      >
        <ChevronLeft className={s.chevron} />
      </button>

      <span className={s.headerTitle}>{title}</span>

      <button
        className={s.navButton}
        aria-label={`Next ${entity}`}
        disabled={!hasNext}
        onClick={onNext}
        type="button"
      >
        <ChevronRight className={s.chevron} />
      </button>
    </div>
  );
};
